/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.js" />
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.binding = skyward.binding || {};

        var defaultSettings =
        {
            title: "Insert Field",
            renderProxies: false,
            removeBaseFromBinding: false,
            onGetBinding: function (/*Binding*/) { },
            onCancel: function () { }
        };

        var init = function (selector)
        {
            var bindingButtons = $(selector).find(".js-bindingButton.js-bindingButtonUnbound");

            bindingButtons.each(function ()
            {
                var bindingButton = $(this);
                var bindingButtonData = bindingButton.data();

                var onBindingButtonClick = function ()
                {
                    if (bindingButtonData.bindingTargetSelector && bindingButtonData.bindingValueOverride)
                    {
                        skyward.global.text.insertTextToken($(bindingButtonData.bindingTargetSelector), bindingButtonData.bindingValueOverride, true);
                    }

                    if (!bindingButtonData.bindingModule || !bindingButtonData.bindingObject)
                    {
                        return;
                    }

                    var settings =
                    {
                        onGetBinding: function (binding)
                        {
                            if (bindingButtonData.bindingTargetSelector)
                            {
                                skyward.global.text.insertTextToken($(bindingButtonData.bindingTargetSelector), binding, true);
                            }
                        },
                        removeBaseFromBinding: bindingButtonData.removeBaseFromBinding
                    };

                    skyward.binding.openBindingDialog(bindingButtonData.bindingModule, bindingButtonData.bindingObject, settings);
                };

                bindingButton.on("click", onBindingButtonClick);
                bindingButton.removeClass("js-bindingButtonUnbound");
            });
        };

        skyward.binding.openBindingDialog = function (module, object, options)
        {
            var settings = $.extend({}, defaultSettings, options);
            var bindingDialog;

            var onSaveClick = function ()
            {
                var binding = getBindingFromTree(bindingDialog, settings);
                bindingDialog.close();
                settings.onGetBinding(binding);
            };
            var onCancelClick = function ()
            {
                bindingDialog.close();
                settings.onCancel();
            };

            var saveButtonDefinition = { text: "Save", "click": onSaveClick, "icon": "Save", additionalClasses: ["js-bindingDialogSave"] };
            var cancelButtonDefinition = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };

            bindingDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButtonDefinition, cancelButtonDefinition], settings);
            var saveButton = bindingDialog.footer.find(".js-bindingDialogSave");
            bindingDialog.content.on("treeBrowseSave", onSaveClick);
            bindingDialog.content.on("treeBrowseRowChange", function (_element, _treeBrowseData, row)
            {
                saveButton.toggle(!row.isRelationship);
            });
        };

        var buildTreePopup = function (module, object, options)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "SkySys/Binding/BuildTreeBrowse/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    module: module,
                    object: object,
                    renderProxies: options.renderProxies
                }
            });
        };

        var getBindingFromTree = function (modalLayer, options)
        {
            var bindingData = skyward.treebrowse.getSelectedFieldData(modalLayer.content);

            if (!bindingData || !bindingData.fieldName || !bindingData.fieldType)
            {
                return formatBinding("");
            }

            if (bindingData.fieldType.toString() != "ManyToOne")
            {
                var fieldName = bindingData.fieldName;

                if (options.removeBaseFromBinding)
                {
                    var dotIndex = bindingData.fieldName.indexOf(".");
                    fieldName = dotIndex <= 0 ? bindingData.fieldName : bindingData.fieldName.substring(dotIndex + 1, bindingData.fieldName.length);
                }

                return formatBinding(fieldName);
            }

            return formatBinding("");
        };

        var formatBinding = function (fieldName)
        {
            return "{" + fieldName + "}";
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
